import Vue from 'vue'
import Antd from 'ant-design-vue'
import '@/assets/styles/antd-variables.less'
Vue.use(Antd)
